export const version = "solidity/5.5.0";
